import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportBoundaryTerritoryGroupContainer, type ExportBoundaryTerritoryGroupContainerProps,
} from './exportBoundaryTerritoryGroup.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportBoundaryTerritoryGroupData: ExportBoundaryTerritoryGroupContainerProps;
  }
}
modalRenderer.register('ExportBoundaryTerritoryGroupData', ExportBoundaryTerritoryGroupContainer);
